import React, { useState }  from 'react'
import { Form, Container, Header} from 'semantic-ui-react'
import { useFormik } from 'formik'
import { initialValues, validationSchema2 } from './AsesorForm.form'
import { DZ } from '../../../../../api'
import { useAuth } from '../../../../../hooks'
import "./AsesorForm.scss";
import ConfirmWithReason from './ConfirmWiithReason'
const DZController = new DZ();

export function AsesorDZForm2(props) {
    const { onClose, onReload, DZ } = props;
    const { accessToken } = useAuth();
    const { user: { email, firstname, lastname } } = useAuth();
    const CorreoAsesor = email;
    const nombreCompleto = `${firstname} ${lastname}`;
    const [showConfirm, setShowConfirm] = useState(false);
    const [BackCancel, setBackCancel] = useState(false);
    const [confirmMessage, setConfirmMessage] = useState("");
    const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);
    

    const formik = useFormik({
        initialValues: initialValues(DZ, CorreoAsesor, nombreCompleto),
        validationSchema: validationSchema2(),
        validateOnChange: false,
        onSubmit: async (formValue) => {
            const data = {
                sAse : true,
            }
            try {
                if (DZ) {
                    await DZController.AproveDZ(accessToken, DZ._id, data);
                } else {
                   console.log("Esto no deberia de pasar")
                }
                onClose();
                onReload();
            } catch (error) {
                console.error(error);
            }
        }
    });
    
    const handleCancel = async (reason) => {
        try {
            if (BackCancel){
                await DZController.CancelDZ(accessToken, DZ._id, reason)
            }else{
                await DZController.RegresarDZ(accessToken, DZ._id, reason)
            }
          onClose();
          onReload();
          onOpenCloseConfirm();
        } catch (error) {
          console.error(error)
        }
      }

      const openDesactivateActivateConfirm = () => {
        setConfirmMessage(`Regresar Formula DZ ${DZ.folio}`);
        onOpenCloseConfirm();
        setBackCancel(false);
      }

      const openDesactivateActivateConfirm2 = () => {
        setConfirmMessage(`Cancelar Formula DZ ${DZ.folio}`);
        onOpenCloseConfirm();
        setBackCancel(true);
      }

      console.log(BackCancel);
    return (
        <Form onSubmit={formik.handleSubmit} className='form'>
            <Container className='cotizacion-principal_info'>
                <p>Asesor: <span className='cotizacion-principal_info-dxp'>{DZ.asesornom}</span></p>
                <p>Correo asesor: <span className='cotizacion-principal_info-dxp'>{DZ.asesor}</span></p>
                <br></br>
                <p>Nombre del producto:<span className='cotizacion-principal_info-dxp'>{DZ.nombre}</span></p>
                <p>Familia del producto:<span className='cotizacion-principal_info-dxp'>{DZ.familia}</span></p>
                <p>Activos: <span className='cotizacion-principal_info-dxp'>{DZ.activos}</span></p>
                <p>Base: <span className='cotizacion-principal_info-base'>{DZ.base}</span></p>
                <p>Presentación: <span className='cotizacion-principal_info-activos'>{DZ.presentacion}</span></p>
                <p>Envase: <span className='cotizacion-principal_info-activos'>{DZ.envase}</span></p>
                <p>Área: <span className='cotizacion-principal_info-dxp'>{DZ.area}</span></p>
                {(DZ.sIyD && DZ.caducidad) && <p>Caducidad: <span className='cotizacion-principal_info-nombre'>{DZ.caducidad}</span></p>}
                <br></br>
                <p>Genero del paciente: <span className='cotizacion-principal_info-base'>{DZ.genero}</span></p>
                <p>Rango de edad: <span className='cotizacion-principal_info-dxp'>{DZ.rangoedad}</span></p>
                <p>Tipo de piel: <span className='cotizacion-principal_info-dxp'>{DZ.tipopiel}</span></p>
                <p>Padecimiento: <span className='cotizacion-principal_info-dxp'>{DZ.padecimiento}</span></p>
                <br></br>
                <p>Precio Objetivo: <span className='cotizacion-principal_info-activos'>{DZ.objetivo}</span></p>
                {DZ.cancelmotivo && <p>Motivo de cancelación: <span className='cotizacion-principal_info-nombre'>{DZ.cancelmotivo}</span></p>}
            </Container>
            <Form.Button type='submit' primary fluid loading={formik.isSubmitting}>
                Aceptar
            </Form.Button>
            <Form.Button type='button' color='orange' fluid onClick={openDesactivateActivateConfirm} >
                Regresar
            </Form.Button>
            <Form.Button type='button' color='red' fluid onClick={openDesactivateActivateConfirm2}>
                Cancelar
            </Form.Button>
            <ConfirmWithReason open={showConfirm} onCancel={onOpenCloseConfirm} onConfirm={handleCancel} content={confirmMessage} size='mini'></ConfirmWithReason>
        </Form>
    )
}
